<main class="home">
  @defer (when true) {
    <div class="content">
      <router-outlet></router-outlet>
    </div>

    <!-- Desktop: barra de navegação no topo da moldura, como a da página da empresa. No celular não existe -->
    @if (desktopMode.enabled()) {
      <agj-home-bottom-menu></agj-home-bottom-menu>
    }
  } @loading (minimum 1500ms) {
    <agj-loading-app></agj-loading-app>
  }
</main>
